import {useEffect, useState} from 'react'

import {useNavigate} from 'react-router-dom'
import {Switch} from '@headlessui/react'
import axios from "axios";
import Cookies from "universal-cookie/es6";
import {XCircleIcon} from "@heroicons/react/20/solid";


function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Login() {
    const navigate = useNavigate();

    const [remember, setRemember] = useState(false)
    const [password, setPassword] = useState("")
    const [email, setEmail] = useState("")
    const [error, setError] = useState("")

    const cookies = new Cookies()

    useEffect(() => {
        console.log("Check the token")
        let loginToken = cookies.get("login-token" )
        console.log("Login Token: ", loginToken)
        if (loginToken !== undefined && loginToken !== "") {
            axios.post(process.env.REACT_APP_API_URL + "validate-token", {"token": loginToken})
                .then(function (response) {
                    console.log("Response: ", response)
                    if (response.data["success"] === true) {
                        console.log("Token Valid, redirect to validate")
                        let now = new Date()
                        now.setMonth(now.getMonth() + 1)
                        cookies.set('name', response.data["result"]["name"], { expires : now, secure: true, domain: process.env.REACT_APP_COOKIE_NAME, path: '/' });
                        navigate('/validate')
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    },[])

    function handlePasswordChange(e) {
        setPassword(e.target.value)
    }

    function handleEmailChange(e) {
        setEmail(e.target.value)
    }

    function onSubmit(event) {
        event.preventDefault()
        cookies.remove("token",{domain: process.env.REACT_APP_COOKIE_NAME, path: '/' })
        let encPassword = btoa(btoa(password))
        axios.post(process.env.REACT_APP_API_URL + "authenticate-user", { "user-name" : email, "password" : encPassword})
            .then(function (response) {
                if (response.data["success"] === true) {
                    console.log("Success")
                    let now = new Date()
                    now.setMinutes(now.getMinutes() + 5)
                    cookies.set('token', response.data["result"]["token"], { expires : now, secure: true, domain: process.env.REACT_APP_COOKIE_NAME, path: '/' });
                    navigate('/verify')
                } else {
                  setError(response.data["error"]["description"])
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    }

    return (

        <div className="flex min-h-full w-full flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <img
                    className="mx-auto h-12 w-auto"
                    src={process.env.REACT_APP_URL + "/images/logo-dark.png"}
                    alt="Your Company"
                />
                <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">Sign in to your
                    account</h2>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <form className="space-y-6" onSubmit={(e) => onSubmit(e)}>
                        { error && <div className="border-l-4 border-red-400 bg-red-50 p-4">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <XCircleIcon className="h-5 w-5 text-red-800" aria-hidden="true" />
                                </div>
                                <div className="ml-3">
                                    <p className="text-sm text-red-700">
                                        {error}
                                    </p>
                                </div>
                            </div>
                        </div>}
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                Email address
                            </label>
                            <div className="mt-1">
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    onChange={handleEmailChange}
                                    required
                                    className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                Password
                            </label>
                            <div className="mt-1">
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    autoComplete="current-password"
                                    onChange={handlePasswordChange}
                                    required
                                    className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                />
                            </div>
                        </div>

                        <div className="flex items-center justify-between">
                            {/*       <Switch.Group as="div" className="flex items-center">
                                <Switch
                                    checked={remember}
                                    onChange={setRemember}
                                    className={classNames(
                                        remember ? 'bg-indigo-600' : 'bg-gray-200',
                                        'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2'
                                    )}
                                >
                                    <span
                                        aria-hidden="true"
                                        className={classNames(
                                            remember ? 'translate-x-5' : 'translate-x-0',
                                            'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                                        )}
                                    />
                                </Switch>
                                <Switch.Label as="span" className="ml-3">
                                    <span className="text-sm font-medium text-gray-900">Remember Me</span>
                                </Switch.Label>
                            </Switch.Group> */}

                            <div className="text-sm">
                                <a href="/forgot" className="font-medium text-indigo-600 hover:text-indigo-500">
                                    Forgot your password?
                                </a>
                            </div>
                        </div>

                        <div>
                            <button
                                type="submit"
                                className="flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            >
                                Sign in
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
